<div class="tournament-board-container">
    <!-- 🌸 桜吹雪 (ご要望により40枚へ増量) 🌸 -->
    <div class="cherry-blossom-container">
        <div class="petal"
            *ngFor="let p of [1,2,3,4,5,6,7,8,9,10,11,12,13,14,15,16,17,18,19,20,21,22,23,24,25,26,27,28,29,30,31,32,33,34,35,36,37,38,39,40]">
        </div>
    </div>

    <!-- 閉じるボタン -->
    <button class="close-board-btn" (click)="close()" title="閉じる">
        <i class="fas fa-times"></i>
    </button>

    <!-- ヘッダー -->
    <header>
        <h1>RAIGO TOURNAMENT</h1>
        <div class="subtitle">Online Championship 2026 - Spring</div>
    </header>

    <!-- フェーズナビゲーター -->
    <nav class="phase-navigator" *ngIf="selectedTournament">
        <div class="phase-selector">
            <div *ngFor="let r of displayRounds" (click)="selectRound(r)"
                [class.active]="!showRanking && ((r.isFinalsGroup && isFinalsRound) || selectedRound === r)"
                class="phase-item">
                {{ r.roundName }}
            </div>
            <div class="phase-item" (click)="toggleRanking()" [class.active]="showRanking">
                順位表
            </div>
        </div>
    </nav>

    <!-- メインコンテンツ -->
    <main>
        <!-- 🏆 順位表表示 🏆 -->
        <div class="ranking-container" *ngIf="showRanking">
            <h2 style="text-align: center; color: #ffb7c5; margin-bottom: 20px;">Current Standings</h2>
            <table class="ranking-table">
                <thead>
                    <tr>
                        <th width="60">位</th>
                        <th>プレイヤー</th>
                        <th width="80">勝ち星</th>
                        <th width="100">GW%</th>
                        <th width="100">OGW%</th>
                    </tr>
                </thead>
                <tbody>
                    <tr *ngFor="let p of rankings; let i = index">
                        <td><span class="rank-badge" [class.rank-1]="i === 0" [class.rank-2]="i === 1"
                                [class.rank-3]="i === 2">{{ i + 1 }}</span></td>
                        <td style="font-weight: bold;">{{ p.name }}</td>
                        <td class="stat-val" style="color: #ffb7c5;">{{ p.wins }}</td>
                        <td class="stat-val">{{ (p.gw * 100).toFixed(0) }}%</td>
                        <td class="stat-val">{{ (p.ogw * 100).toFixed(0) }}%</td>
                    </tr>
                </tbody>
            </table>
        </div>

        <ng-container *ngIf="selectedRound">
            <!-- 🌀 通常ラウンド (スイスドロー等) 🌀 -->
            <div class="room-grid" *ngIf="!isFinalsRound">
                <div class="room-card glass-card" *ngFor="let room of selectedRound?.rooms">
                    <div class="card-header">
                        <div class="room-name-large">{{ room.roomName }}</div>
                        <button class="icon-btn log-btn-large" *ngIf="room.winner" (click)="loadLog(room.roomId!)"
                            title="ログを見る">
                            <i class="fas fa-history"></i>
                        </button>
                    </div>
                    <div class="match-area-large">
                        <div class="player-box left-side" [class.winner]="room.winner === room.player1"
                            [class.loser]="room.winner && room.winner !== room.player1">
                            <div class="player-name-large">{{ room.player1 }}</div>
                            <button *ngIf="!room.winner" class="join-btn-large"
                                (click)="joinRoom(room, room.player1)">入室</button>
                        </div>
                        <div class="vs-section">
                            <i class="fas fa-bolt vs-bolt" [class.active-match]="!room.winner"
                                [class.finished-match]="room.winner"></i>
                        </div>
                        <div class="player-box right-side" [class.winner]="room.winner === room.player2"
                            [class.loser]="room.winner && room.winner !== room.player2">
                            <div class="player-name-large">{{ room.player2 }}</div>
                            <button *ngIf="!room.winner && room.player2 !== '(Bye)'" class="join-btn-large"
                                (click)="joinRoom(room, room.player2)">入室</button>
                        </div>
                    </div>
                </div>
            </div>

            <!-- 🏆 決勝トーナメント 🏆 -->
            <div class="tournament-bracket" *ngIf="isFinalsRound">
                <div class="bracket-column" *ngFor="let round of finalsRounds; let rIdx = index"
                    [class]="'round-' + (rIdx+1)">
                    <div class="round-title">{{ round.roundName }}</div>
                    <div class="bracket-matches">
                        <div class="bracket-pair" *ngFor="let pair of getPairs(round.rooms)">
                            <div class="bracket-match-node" *ngFor="let room of pair">
                                <div class="match-box glass-card">
                                    <div class="match-header-row">
                                        <span class="room-tag">{{ room.roomName }}</span>
                                        <button class="icon-btn log-btn" *ngIf="room.winner"
                                            (click)="loadLog(room.roomId!)" title="Log">
                                            <i class="fas fa-history"></i>
                                        </button>
                                    </div>
                                    <div class="match-content">
                                        <!-- Player 1 -->
                                        <div class="bracket-player-row" [class.is-winner]="room.winner === room.player1"
                                            [class.is-loser]="room.winner && room.winner !== room.player1">
                                            <span class="p-name">{{ room.player1 }}</span>
                                            <button class="icon-btn join-btn" *ngIf="!room.winner"
                                                (click)="joinRoom(room, room.player1)" title="Join">
                                                <i class="fas fa-sign-in-alt"></i>
                                            </button>
                                            <span class="win-mark" *ngIf="room.winner === room.player1">WIN</span>
                                        </div>
                                        <!-- Player 2 -->
                                        <div class="bracket-player-row" [class.is-winner]="room.winner === room.player2"
                                            [class.is-loser]="room.winner && room.winner !== room.player2">
                                            <span class="p-name">{{ room.player2 }}</span>
                                            <button class="icon-btn join-btn"
                                                *ngIf="!room.winner && room.player2 !== '(Bye)'"
                                                (click)="joinRoom(room, room.player2)" title="Join">
                                                <i class="fas fa-sign-in-alt"></i>
                                            </button>
                                            <span class="win-mark" *ngIf="room.winner === room.player2">WIN</span>
                                        </div>
                                    </div>

                                    <!-- Horizontal Line Out (Individual) -->
                                    <div class="line-out" *ngIf="rIdx < finalsRounds.length - 1"></div>
                                </div>
                            </div>

                            <!-- Connector Vertical Bridge (Shared by Pair) -->
                            <div class="connector-bridge" *ngIf="pair.length > 1 && rIdx < finalsRounds.length - 1">
                                <div class="bridge-vertical"></div>
                                <div class="bridge-horizontal"></div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </ng-container>
    </main>
</div>